import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";
import { UtilService } from "@app/modules/shared/services/util.service";
import { Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";

@Injectable()
export class MaterialInfoService {
  private baseUrl() {
    return (
      (localStorage.getItem("apiUrl")
        ? localStorage.getItem("apiUrl")
        : environment.apiUrl) + "/"
    );
  }

  constructor(
    private utilService: UtilService,
    private httpClient: HttpClient
  ) {}

  materialInfo(
    acceptedObject,
    endpoint,
    collection?: any,
    filterObject?
  ): Observable<any> {
    let postObject = Object.create(null);
    if (acceptedObject.length > 1) {
      postObject[acceptedObject[1]] =
        collection.flexGrid.rows[collection.row].dataItem[acceptedObject[0]][
          acceptedObject[1]
        ];
    } else {
      postObject = { ...acceptedObject };
    }
    if (filterObject) {
      Object.assign(postObject, filterObject);
    }
    return this.httpClient
      .post<any>(this.baseUrl() + endpoint + "/material-info", postObject)
      .pipe(
        map((response) => (response.data[0] ? response.data[0] : null)),
        catchError((error) => throwError(error))
      );
  }

  retailMaterialInfo(
    acceptedObject,
    branch,
    endpoint,
    collection?: any,
    filterObject?
  ): Observable<any> {
    return this.infoFunction(
      acceptedObject,
      branch,
      endpoint + "/retail-material-info",
      collection,
      filterObject
    );
  }

  labelPrintInfo(
    acceptedObject,
    branch,
    endpoint,
    collection?: any,
    filterObject?
  ): Observable<any> {
    return this.infoFunction(
      acceptedObject,
      branch,
      endpoint + "/label-print-info",
      collection,
      filterObject
    );
  }

  labelPrintBulkInfo(acceptedObject, branch, endpoint): Observable<any> {
    return this.infoFunction(
      acceptedObject,
      branch,
      endpoint + "/label-print-info",
      null,
      null,
      true
    );
  }

  infoFunction(
    acceptedObject,
    branch,
    endpoint,
    collection?: any,
    filterObject?,
    bulkAction = false
  ): Observable<any> {
    if (filterObject) {
      Object.assign(acceptedObject, filterObject);
    }
    Object.assign(acceptedObject, {
      branch: {
        id: branch.id,
      },
    });
    return this.httpClient
      .post<any>(this.baseUrl() + endpoint, { filter: acceptedObject })
      .pipe(
        map((response) =>
          response.data[0]
            ? bulkAction
              ? response.data
              : response.data[0]
            : null
        ),
        catchError((error) => throwError(error))
      );
  }
}
